var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationNavbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6395 3.00195C9.22445 3.00195 6.44905 5.77735 6.44905 9.19243V12.1742C6.44905 12.8035 6.1808 13.7631 5.86096 14.2996L4.67445 16.2702C3.94191 17.4877 4.44747 18.8393 5.78874 19.2932C10.2356 20.7789 15.0332 20.7789 19.48 19.2932C20.7284 18.8805 21.2752 17.4051 20.5943 16.2702L19.4078 14.2996C19.0983 13.7631 18.83 12.8035 18.83 12.1742V9.19243C18.83 5.78767 16.0443 3.00195 12.6395 3.00195Z",
    stroke: "#949699",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5484 3.30195C14.2286 3.2091 13.8984 3.13687 13.5579 3.0956C12.5675 2.97179 11.6183 3.04402 10.731 3.30195C11.0302 2.53846 11.773 2.00195 12.6397 2.00195C13.5064 2.00195 14.2492 2.53846 14.5484 3.30195Z",
    stroke: "#949699",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7349 19.666C15.7349 21.3684 14.3421 22.7613 12.6397 22.7613C11.7936 22.7613 11.0095 22.4105 10.4524 21.8533C9.89523 21.2962 9.54443 20.512 9.54443 19.666",
    stroke: "#949699",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNavbar);
export default __webpack_public_path__ + "static/media/notification-navbar.977b32558662318d5b61a04b8d5e9ac8.svg";
export { ForwardRef as ReactComponent };